import React from "react";

import { Helmet } from "react-helmet";

import { MenusList } from "features/MenusList";
import { PageTitle } from "shared/ui";

const TITLE = "Мои меню";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/MenusList.
const MenusListPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <MenusList />
        </>
    );
};

export default MenusListPage;
